import type { JSX } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import type { VerificationRequestStatus } from '@/features/verifications/types/verification.types';
import { buildReferenceSummary } from '../utils/reference-summary';

interface ExperienceContactsSummaryProps {
  statuses: VerificationRequestStatus[];
  isExpanded: boolean;
}

export function ExperienceContactsSummary({
  statuses,
  isExpanded,
}: ExperienceContactsSummaryProps): JSX.Element {
  const Chevron = isExpanded ? ChevronDown : ChevronRight;
  const summary = buildReferenceSummary(statuses);

  return (
    <span className="flex w-full items-center justify-between gap-3 text-left">
      <span className="font-medium">Reference contact</span>
      <span className="ml-auto flex items-center gap-2 text-sm text-muted-foreground">
        {summary && <span>{summary}</span>}
        <Chevron
          data-testid="contacts-chevron"
          data-expanded={isExpanded}
          className="h-4 w-4"
          aria-hidden="true"
        />
      </span>
    </span>
  );
}
